import { useCallback, useEffect } from 'react'
import { useParams } from 'react-router'
import { Onboardings } from '@/core/enums/onboardings'
import { useOnboarding } from '@/core/hooks/use-onboarding'
import { stepsFirstPage } from '../components/steps'

export const useUsuarioEdicaoFirstPageOnboarding = openOnboarding => {
  const {
    currentUserOnboardingIsSeen,
    setSteps,
    setOpen,
    loading,
    save,
    setCurrentStep
  } = useOnboarding(Onboardings.USUARIO_EDICAO_FIRST_PAGE)
  const params = useParams()

  const setNextStepAndOpen = useCallback(() => {
    if (params.id || currentUserOnboardingIsSeen) return
    setCurrentStep(0)
    setSteps?.([stepsFirstPage(save)[1]])
    setOpen()
  }, [
    params.id,
    setSteps,
    save,
    setOpen,
    setCurrentStep,
    currentUserOnboardingIsSeen
  ])

  useEffect(() => {
    if (!currentUserOnboardingIsSeen && !loading && openOnboarding) {
      // se o usuario estiver editando um usuario existente e não fez o onboarding ainda, carrega todos os steps
      // caso contrario carrega apenas o primeiro, o segundo será carregado dinamicamente ao selecionar opções
      setCurrentStep(0)
      if (params.id) {
        setSteps?.(stepsFirstPage(save))
      } else {
        setSteps?.([stepsFirstPage()[0]])
      }
      setOpen()
    }
  }, [
    currentUserOnboardingIsSeen,
    loading,
    params.id,
    save,
    setOpen,
    setSteps,
    setCurrentStep,
    openOnboarding
  ])

  return { setNextStepAndOpen }
}
